class Metadata {
  constructor({accountname, source, videoid}, serviceUrl) {
    this.metadata = {};
    this.url      = `${serviceUrl}/videos/source/${source}/account/${accountname}/${videoid}.json`;
  }

  fetch() {
    if (this.promise) { return this.promise.then((json) => json.video.metadata); }

    this.promise = Voonto.$.ajax(this.url, {
      dataType: 'json'
    });

    return this.promise.then((json) => json.video.metadata);
  }
}

export default Metadata;



// WEBPACK FOOTER //
// ./src/models/metadata.js